import Header from '@components/Header/Header'
import { Separator } from '@components/ui/separator.tsx'
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@components/ui/sidebar.tsx'
import { useTSRBreadCrumbs } from '@hooks/use-tsr-breadcrumbs.ts'
import { AppBreadcrumbs } from '@layouts/RoleBasedLayout/components/app-breadcrumbs.tsx'
import { AppSidebar } from '@layouts/RoleBasedLayout/components/app-sidebar.tsx'
import { ProfileButton } from '@layouts/RoleBasedLayout/components/ProfileButton.tsx'
import { capitalizeFirstLetter } from '@utils/helper-functions'
import localizedPages from '@utils/i18n-to-migrate/pages.no.json'
import type { ReactNode } from 'react'

interface RoleBasedLayoutProps {
  children: ReactNode
}

export const RoleBasedLayout = ({ children }: RoleBasedLayoutProps) => {
  const { breadcrumb_routes } = useTSRBreadCrumbs()

  const title = breadcrumb_routes[breadcrumb_routes.length]
    ? capitalizeFirstLetter(localizedPages[breadcrumb_routes[breadcrumb_routes.length - 1].name])
    : ''

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <div className="flex min-w-0 flex-col bg-viken-rock-100">
          <header className="flex shrink-0 items-center gap-2 px-8 pt-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 data-[orientation=vertical]:h-4" />
            <AppBreadcrumbs />
            <ProfileButton />
          </header>
          <div className="flex min-w-0 flex-1 flex-col p-8">
            {title.length > 0 && <Header title={title} />}
            {children}
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
